module.exports = __webpack_public_path__ + "media/images/samplePick-57f9d96e93d465576cb00c1808085daf.png";